// src/components/CreateSelectionGroup.tsx

import React, { useState } from 'react';
import { Modal, Button, Form, Spinner } from 'react-bootstrap';
import { CreateSelectionModifier } from '../../../../../../../../crud/menu_api/selection_modifiers';
import { toast } from 'react-toastify';
import MiniLoadingSpinner from '../../../../../../../../components/Spinners/MiniLoadingSpinner';
import { X } from 'react-bootstrap-icons';
import './CreateModifierModal.scss';

interface Modifier {
  modifier_id: number;
  modifier_name: string;
  modifier_description?: string;
  local_id: number;
  items_affected: Array<{
    item_id: number;
    item_name: string;
  }>;
  options_included: Array<{
    option_id: number;
    option_name: string;
  }>;
}

interface CreateSelectionGroupProps {
  show: boolean;
  handleClose: () => void;
  modifiers: Modifier[];
  setModifiers: (items: Modifier[]) => void;
}

const CreateModifierModal: React.FC<CreateSelectionGroupProps> = ({
  show,
  handleClose,
  modifiers,
  setModifiers,
}) => {
  const [modifierName, setModifierName] = useState<string>('');
  const [modifierDescription, setModifierDescription] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    // Validación: nombre obligatorio
    if (modifierName.trim() === '') {
      toast.error('El nombre del grupo es obligatorio.');
      setLoading(false);
      return;
    }

    // Validación: descripción obligatoria
    

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const localId = user?.local_id || 0;

    if (localId === 0) {
      toast.error('No se pudo obtener el ID local del usuario.');
      setLoading(false);
      return;
    }

    const payload = {
      modifier_name: modifierName.trim(),
      modifier_description: modifierDescription.trim(),
      local_id: localId,
    };

    try {
      const response = await CreateSelectionModifier(payload);
      toast.success('Grupo de modificadores creado exitosamente.');
      setModifiers([...modifiers, (response as any).data]);
      setModifierName('');
      setModifierDescription('');
      handleClose();
    } catch (error: any) {
      console.error('Error creando el grupo de modificadores', error);
      const message = error.response?.data?.message || 'Error al crear el grupo de modificadores';
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    if (!loading) {
      setModifierName('');
      setModifierDescription('');
      handleClose();
    }
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg" className="create-modifier-modal">
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <div className="form-modal-title-container">
            <Modal.Title className="form-modal-title">Crear opción</Modal.Title>
          </div>
          <Button 
            variant="none" 
            className="modal-close-button" 
            onClick={handleModalClose}
            disabled={loading}
          >
            <X size={24} />
          </Button>
        </Modal.Header>

        {loading && <MiniLoadingSpinner left="50%" />}

        {!loading && (
          <Modal.Body>
            {/* Nombre del Grupo */}
            <Form.Group controlId="groupName" className="mb-3">
              <Form.Label>
                Nombre del grupo <span style={{ color: 'red' }}>*</span>
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Ingrese el nombre del grupo"
                value={modifierName}
                onChange={(e) => setModifierName(e.target.value)}
                required
                className='form-control-Selection-Group'
              />
            </Form.Group>

            {/* Descripción del Grupo */}
            <Form.Group controlId="groupDescription" className="mb-3">
              <Form.Label>
                Descripción
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                placeholder="Elige entre tus agregados favoritos"
                value={modifierDescription}
                onChange={(e) => setModifierDescription(e.target.value)}
                className='form-control-Selection-Group'
              />
            </Form.Group>
          </Modal.Body>
        )}

        <Modal.Footer>
          <Button
            className="form-button-cancel"
            variant="secondary"
            onClick={handleModalClose}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            className="form-button-create"
            variant="primary"
            type="submit"
            disabled={loading || !modifierName.trim() }
          >
            {loading ? (
              <>
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />{' '}
                Creando...
              </>
            ) : (
              'Crear Modificador'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateModifierModal;
